import React, { useState, useEffect } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {
  Button,
  Divider,
  Grid,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  makeStyles,
  styled,
} from "@material-ui/core";
import styles from "./Menu.module.css";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Slide from "@material-ui/core/Slide";
import logo from "../../assets/images/logo.svg";
import coinicon from "../../assets/images/coin-icon.svg";
import call from "../../assets/images/phone.svg";
import mail from "../../assets/images/mail.svg";
import contactus from "../../assets/images/contact-us.svg";
import Hamburger from "../../commomComponents/hamburger";
import PMSImg from "../../assets/images/PMS.png";
import AIFImg from "../../assets/images/AIF.png";
import ArrowLeft from "../../assets/images/arrow-left.png";
import { HOST_URL, SITE_ID } from "../../services/apiConstants";
import { getInvestorCharter } from "../../services/request/home";
import { ArrowDropDownCircleOutlined } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import ResponsiveDialog from "../../commomComponents/Dialog";

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export default function Header(props) {
  const [aboutUs, setAboutUs] = useState(false);
  const [ourOffering, setOurOffering] = useState(false);
  const [existingInvestor, setExistingInvestor] = useState(false);
  const [investerCorner, setInvesterCorner] = useState(false);
  const [newsroom, setNewsroom] = useState(false);
  const [contactUs, setContactUs] = useState(false);
  const [InvestorGrievance, setInvestorGrievance] = useState(false);
  const [faqs, setFaqs] = useState(false);
  const [investWithUsDirectly, setInvestWithUsDirectly] = useState(false);
  const [aifs, setAifs] = useState(false);
  const [login, setLogin] = useState(false);
  const [charterPDF, setCharterPDF] = useState("");
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [activeTab, setActiveTab] = React.useState("tab1");
  const [activeTab1, setActiveTab1] = React.useState("tab");
  const [activeTab2, setActiveTab2] = React.useState("tab");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);

  const [initialMount, setInitialMount] = useState(true);
  const [openDialog, setOpenDialog] = React.useState(false);

  const open = Boolean(anchorEl);
  const open1 = Boolean(anchorEl1);
  const open2 = Boolean(anchorEl2);

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const handleChange1 = (event, newValue) => {
    setActiveTab1(newValue);
  };

  const handleChange2 = (event, newValue) => {
    setActiveTab2(newValue);
  };

  const handleMoreClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMoreClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleMoreClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleMoreClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    // Close the menu when the component mounts
    if (initialMount) {
      handleMoreClose();
      setInitialMount(false);
    }
  }, [initialMount, setAnchorEl]);

  const handleMoreClose1 = () => {
    setAnchorEl1(null);
  };

  const handleMoreClose2 = () => {
    setAnchorEl2(null);
  };

  const handleMenuItemClick = (value) => {
    setActiveTab(value);
    setAnchorEl(null);
  };
  const tabsData = [
    {
      label: "PMS",
      value: "PMS",
      link: "/portfolio-management-service",
      img: { PMSImg },
      desc: "",
    },
    {
      label: "AIF",
      value: "AIF",
      link: "/alternative-investment-funds",
      img: { AIFImg },
      desc: "",
    },
  ];
  const ConatactUsAndInvestNowData = [
    {
      label: "Existing Investor",
      value: "Existing Investor",
      link: "/existing-investor",
    },
    { label: "New Investor ", value: "New Investor ", link: "/invest-with-us" },
  ];
  useEffect(() => {
    const charter = getInvestorCharter();
    charter.then((data) => {
      window.addEventListener("resize", handleResize, false);
      if (data.data.investorCharter.length > 0) {
        setCharterPDF(data.data.investorCharter[0].file.item.value);
      }
    });
  }, []);

  const handleResize = () => {
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };
  const onMouseLeaveEvent = (type) => {
    switch (type) {
      case "aboutUs":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setInvestWithUsDirectly(false);
        setAifs(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);
        return;
      case "ourOffering":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setInvestWithUsDirectly(false);
        setAifs(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);

        return;
      case "investerCorner":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setInvestWithUsDirectly(false);
        setAifs(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);

        return;
      case "newsroom":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setContactUs(false);
        setInvestWithUsDirectly(false);
        setAifs(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);

        return;
      case "InvestorGrievance":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setContactUs(false);
        setInvestWithUsDirectly(false);
        setAifs(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);

        return;
      case "contactus":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setContactUs(false);
        setInvestWithUsDirectly(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);

        return;
      case "existinginvestorandnewinvestor":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setContactUs(false);
        setInvestWithUsDirectly(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);

        return;
      case "faqs":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setInvestWithUsDirectly(false);
        setAifs(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);

        return;
      case "investWithUsDirectly":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setInvestWithUsDirectly(false);
        setAifs(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);

        return;

      case "aifs":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setExistingInvestor(false);
        setInvestWithUsDirectly(false);
        setAifs(false);
        setInvestorGrievance(false);
        return;

      case "login":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setInvestWithUsDirectly(false);
        setAifs(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);
        setLogin(false);
        return;
    }
  };

  const onMouseEnterEvent = (type) => {
    switch (type) {
      case "aboutUs":
        setAboutUs(true);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setExistingInvestor(false);
        setInvestWithUsDirectly(false);
        setInvestorGrievance(false);
        return;
      case "ourOffering":
        setAboutUs(false);
        setOurOffering(true);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setExistingInvestor(false);
        setInvestWithUsDirectly(false);
        setInvestorGrievance(false);
        return;
      case "investerCorner":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(true);
        setNewsroom(false);
        setFaqs(false);
        setInvestWithUsDirectly(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);
        return;
      case "newsroom":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(true);
        setFaqs(false);
        setContactUs(false);
        setInvestWithUsDirectly(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);
        return;

      case "InvestorGrievance":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setInvestorGrievance(true);
        setFaqs(false);
        setContactUs(false);
        setInvestWithUsDirectly(false);
        setExistingInvestor(false);
        return;
      case "contactus":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setContactUs(true);
        setInvestWithUsDirectly(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);

        return;
      case "existinginvestorandnewinvestor":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setContactUs(false);
        setInvestWithUsDirectly(false);
        setExistingInvestor(true);
        setInvestorGrievance(false);

        return;
      case "faqs":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(true);
        setInvestWithUsDirectly(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);
        return;
      case "investWithUsDirectly":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setInvestWithUsDirectly(true);
        setExistingInvestor(false);
        setInvestorGrievance(false);
        return;
      case "aifs":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setInvestWithUsDirectly(false);
        setAifs(true);
        setExistingInvestor(false);
        setInvestorGrievance(false);
        return;

      case "login":
        setAboutUs(false);
        setOurOffering(false);
        setInvesterCorner(false);
        setNewsroom(false);
        setFaqs(false);
        setInvestWithUsDirectly(false);
        setAifs(false);
        setExistingInvestor(false);
        setInvestorGrievance(false);
        setLogin(true);
        return;
    }
    setAboutUs(true);
  };

  const aboutusStyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    // marginTop: 15,
    color: aboutUs ? "#97291e" : "#fff",
    fontWeight: "600",
    // backgroundColor: aboutUs ? "#efdfdd" : "white",
  };
  const ourOfferingStyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    // marginTop: 15,
    fontWeight: "600",
    color: ourOffering ? "#97291e" : "#fff",

    // backgroundColor: ourOffering ? "#efdfdd" : "white",
  };

  const existinginvestorAndNewinvestorstyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    // marginTop: 15,
    fontWeight: "600",
    color: existingInvestor ? "#97291e" : "#fff",

    // backgroundColor: ourOffering ? "#efdfdd" : "white",
  };

  const loginstyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    // marginTop: 15,
    fontWeight: "600",
    color: login ? "#97291e" : "#fff",

    // backgroundColor: ourOffering ? "#efdfdd" : "white",
  };
  const investCornerStyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    // marginTop: 15,
    fontWeight: "600",
    color: investerCorner ? "#97291e" : "#fff",

    // backgroundColor: investerCorner ? "#efdfdd" : "white",
  };
  const newsRoomStyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    fontWeight: "600",
    color: newsroom ? "#97291e" : "#fff",

    // marginTop: 15,
    // backgroundColor: newsroom ? "#efdfdd" : "white",
  };
  const InvestorGrievanceStyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    fontWeight: "600",
    color: InvestorGrievance ? "#97291e" : "#fff",

    // marginTop: 15,
    // backgroundColor: newsroom ? "#efdfdd" : "white",
  };

  const investnowStyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    fontWeight: "600",
    color: investWithUsDirectly ? "#97291e" : "#fff",

    // marginTop: 15,
    // backgroundColor: newsroom ? "#efdfdd" : "white",
  };
  const contactusStyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    fontWeight: "500",
    color: contactUs ? "#97291e" : "#fff",

    // marginTop: 15,
    // backgroundColor: contactUs ? "#efdfdd" : "white",
  };
  const faqsStyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    // marginTop: 15,
    fontWeight: "500",
    color: faqs ? "#97291e" : "#fff",

    // backgroundColor: faqs ? "#efdfdd" : "white",
  };

  const aifsStyle = {
    paddingLeft: 15,
    borderRadius: 100,
    height: 20,
    // marginTop: 15,
    fontWeight: "500",
    color: aifs ? "#97291e" : "#fff",

    // backgroundColor: aifs ? "#efdfdd" : "white",
  };
  const menuStyle = {
    menu: {
      borderRadius: "30px",
    },
  };
  const useStyles = makeStyles({
    paper: {
      "& .MuiMenu-paper": {
        borderRadius: 10,
        overflowY: "hidden",
      },
    },
  });

  const classes = useStyles();
  const history = useHistory();

  // Function to scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // Function to handle navigation and scroll to top
  const handleNavigation = (path, name) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event:
        name === "Portfolio Management Services" ||
        name === "Alternative Investment Funds"
          ? "TopNavigation_L1_Selected"
          : "TopNavigation_Selected",
      inquiryType: "",
      buttonName: name,
      email: "", // Encrypted email of the User using SHA-256 encryption
      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
      clientID: "",
      queryMessage: "",
      state: "",
      pageSection: "",
      Category: "",
      FAQ: "",
    });
    history.push(path);
    scrollToTop();
  };

  const handleNavigation1 = (path) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "TopNavigation_Selected",
      inquiryType: "",
      buttonName: "Investor Grievance",
      email: "", // Encrypted email of the User using SHA-256 encryption
      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
      clientID: "",
      queryMessage: "",
      state: "",
      pageSection: "",
      Category: "",
      FAQ: "",
    });
    history.push(path);

    // Delay the scroll by 1000 milliseconds (1 second)
    setTimeout(() => {
      window.scrollTo(0, 2150);
    }, 500);
  };

  return (
    <>
      {/* <HideOnScroll {...props}> */}
      <AppBar position="fixed" style={{ backgroundColor: "#fff" }}>
        {openDialog && (
          <ResponsiveDialog open={openDialog} handleClose={handleClose} />
        )}
        <Toolbar className={styles.scrollbar}>
          <div className={styles.float_left}>
            <img
              src={logo}
              className={styles.logoHome}
              alt=""
              onClick={() => handleNavigation("/")}
            />
          </div>
        </Toolbar>
        {/* <ElevationScroll {...props}> */}
        {dimensions.width >= 1000 ? (
          <Toolbar className={styles.appbar}>
            <Tabs indicatorColor="secondary" className={styles.tabs}>
              {dimensions.width >= 1000 && (
                <div className={styles.navbarContainer}>
                  <div className={styles.tabsContainer}>
                    <Tab
                      style={aboutusStyle}
                      onMouseEnter={() => onMouseEnterEvent("aboutUs")}
                      onMouseLeave={() => onMouseLeaveEvent("aboutUs")}
                      label="About Us"
                      onClick={() => {
                        handleNavigation("/about-us", "About Us");
                      }}
                    />
                    <Tab
                      style={ourOfferingStyle}
                      value={activeTab}
                      label="Offerings"
                      onChange={handleChange}
                      onMouseEnter={() => onMouseEnterEvent("ourOffering")}
                      onMouseLeave={() => onMouseLeaveEvent("ourOffering")}
                      onClick={handleMoreClick}
                      variant="scrollable"
                      scrollButtons="auto"
                    />

                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      className={classes.paper}
                      onClose={handleMoreClose}
                      style={{
                        marginTop: "55px",
                        marginLeft: "-5px",
                      }}
                    >
                      <div
                        className={styles.triangleupsidedown}
                        // style={{ marginLeft: "calc(50% - 10px)" }}
                      ></div>
                      <Grid
                        container
                        rowSpacing={4}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        style={{
                          width: "300px",
                          height: "96px",
                          padding: "10px",
                          borderRadius: "10px",
                        }}
                      >
                        <Grid style={{ display: "flex" }}></Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: "1",
                          }}
                        >
                          <Grid
                            item
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handleNavigation(
                                "/portfolio-management-service",
                                "Portfolio Management Services"
                              );
                              handleMoreClose();
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Link
                                to="/portfolio-management-service"
                                style={{
                                  marginLeft: "10px",
                                  color: "#97291E",
                                  fontWeight: "600",
                                  lineHeight: "20px",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Portfolio Management Services
                              </Link>

                              <img src={ArrowLeft} alt="arrow" />
                            </div>
                          </Grid>

                          <div style={{ marginTop: "15px" }}>
                            <Divider />
                          </div>

                          <Grid
                            item
                            style={{ marginTop: "20px", cursor: "pointer" }}
                            onClick={() => {
                              handleNavigation(
                                "/alternative-investment-funds",
                                "Alternative Investment Funds"
                              );
                              handleMoreClose();
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Link
                                to="/alternative-investment-funds"
                                style={{
                                  marginLeft: "10px",
                                  color: "#97291E",
                                  fontWeight: "600",
                                  lineHeight: "20px",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Alternative Investment Funds
                              </Link>
                              <img src={ArrowLeft} alt="arrow" />
                            </div>
                          </Grid>
                        </div>
                      </Grid>
                    </Menu>

                    <Tab
                      onMouseEnter={() => onMouseEnterEvent("investerCorner")}
                      onMouseLeave={() => onMouseLeaveEvent("investerCorner")}
                      style={investCornerStyle}
                      label="Investor Corner"
                      onClick={() => {
                        handleNavigation(
                          "/investors-corner",
                          "Investor Corner"
                        );
                      }}
                    />

                    <Tab
                      onMouseEnter={() => onMouseEnterEvent("newsroom")}
                      onMouseLeave={() => onMouseLeaveEvent("newsroom")}
                      style={newsRoomStyle}
                      label="Insights"
                      onClick={() => {
                        handleNavigation("/market-insights", "Insights");
                      }}
                    />

                    <Tab
                      style={existinginvestorAndNewinvestorstyle}
                      value={activeTab1}
                      label="Invest Now"
                      onChange={handleChange1}
                      onMouseEnter={() =>
                        onMouseEnterEvent("existinginvestorandnewinvestor")
                      }
                      onMouseLeave={() =>
                        onMouseLeaveEvent("existinginvestorandnewinvestor")
                      }
                      onClick={handleMoreClick1}
                      variant="scrollable"
                      scrollButtons="auto"
                    />

                    <Menu
                      anchorEl={anchorEl1}
                      open={open1}
                      className={classes.paper}
                      onClose={handleMoreClose1}
                      style={{ marginTop: "55px", marginLeft: "-17px" }}
                    >
                      <div
                        className={styles.triangleupsidedown1}
                        style={{ marginLeft: "calc(50% - 10px)" }}
                      ></div>
                      <Grid
                        container
                        rowSpacing={4}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        style={{
                          width: "300px",
                          height: "96px",
                          padding: "10px",
                          borderRadius: "10px",
                        }}
                      >
                        <Grid style={{ display: "flex" }}></Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: "1",
                          }}
                        >
                          <Grid
                            item
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handleNavigation(
                                "/existing-investor",
                                "Existing Investor"
                              );
                              handleMoreClose1();
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Link
                                to="/existing-investor"
                                style={{
                                  marginLeft: "10px",
                                  color: "#97291E",
                                  fontWeight: "600",
                                  lineHeight: "20px",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Existing Investor
                              </Link>

                              <img src={ArrowLeft} alt="arrow" />
                            </div>
                          </Grid>

                          <div style={{ marginTop: "15px" }}>
                            <Divider />
                          </div>

                          <Grid
                            item
                            style={{ marginTop: "20px", cursor: "pointer" }}
                            onClick={() => {
                              handleNavigation(
                                "/invest-with-us",
                                "New Investor"
                              );
                              handleMoreClose1();
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Link
                                to="/invest-with-us"
                                style={{
                                  marginLeft: "10px",
                                  color: "#97291E",
                                  fontWeight: "600",
                                  lineHeight: "20px",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                New Investor
                              </Link>
                              <img src={ArrowLeft} alt="arrow" />
                            </div>
                          </Grid>
                        </div>
                      </Grid>
                    </Menu>

                    <Tab
                      onMouseEnter={() =>
                        onMouseEnterEvent("InvestorGrievance")
                      }
                      onMouseLeave={() =>
                        onMouseLeaveEvent("InvestorGrievance")
                      }
                      style={InvestorGrievanceStyle}
                      label="Investor Grievance"
                      onClick={() => {
                        handleNavigation1(
                          "/investors-corner#InvestorGrievance"
                        );
                      }}
                    />
                  </div>

                  <div className={styles.investorLoginButton}>
                    <Tab
                      style={loginstyle}
                      // value={activeTab2}
                      label="AIF Login"
                      // onChange={handleChange2}
                      // onMouseEnter={() => onMouseEnterEvent("login")}
                      // onMouseLeave={() => onMouseLeaveEvent("login")}
                      onClick={() => {
                        window.open(
                          "https://apps.iciciprupms.com/VCF_AIF_WEB?Flag=E"
                        );
                        // handleMoreClose2();
                      }}
                      variant="scrollable"
                      scrollButtons="auto"
                    />
                    <Tab
                      style={loginstyle}
                      // value={activeTab2}
                      label="PMS Login"
                      // onChange={handleChange2}
                      // onMouseEnter={() => onMouseEnterEvent("login")}
                      // onMouseLeave={() => onMouseLeaveEvent("login")}
                      onClick={handleMoreClick2}
                      variant="scrollable"
                      scrollButtons="auto"
                    />
                    <Menu
                      anchorEl={anchorEl2}
                      open={open2}
                      className={classes.paper}
                      onClose={handleMoreClose2}
                      style={{ marginTop: "55px", marginLeft: "-17px" }}
                    >
                      <div
                        className={styles.triangleupsidedown2}
                        style={{ marginLeft: "calc(50% - 10px)" }}
                      ></div>
                      <Grid
                        container
                        rowSpacing={4}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        style={{
                          width: "300px",
                          height: "120px",
                          padding: "10px",
                          borderRadius: "10px",
                        }}
                      >
                        <Grid style={{ display: "flex" }}></Grid>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: "1",
                          }}
                        >
                          <Grid item style={{ cursor: "pointer" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Button
                                style={{
                                  marginLeft: "10px",
                                  color: "#97291E",
                                  fontWeight: "600",
                                  lineHeight: "20px",
                                  letterSpacing: "0.5px",
                                  textTransform: "capitalize",
                                }}
                                onClick={() => {
                                  window.open(
                                    "https://www.iciciprualternates.com/portal"
                                  );
                                  handleMoreClose2();
                                }}
                              >
                                Experience the new website
                              </Button>

                              <img src={ArrowLeft} alt="arrow" />
                            </div>
                          </Grid>

                          <div style={{ marginTop: "15px" }}>
                            <Divider />
                          </div>

                          <Grid
                            item
                            style={{ marginTop: "20px", cursor: "pointer" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Button
                                style={{
                                  marginLeft: "10px",
                                  color: "#97291E",
                                  fontWeight: "600",
                                  lineHeight: "20px",
                                  letterSpacing: "0.5px",
                                  textTransform: "capitalize",
                                }}
                                onClick={() => {
                                  handleClickOpen();
                                  handleMoreClose2();
                                }}
                              >
                                Continue with old website
                              </Button>
                              <img src={ArrowLeft} alt="arrow" />
                            </div>
                          </Grid>
                        </div>
                      </Grid>
                    </Menu>
                  </div>
                </div>
              )}
            </Tabs>

            {/* {dimensions.width <= 1000 && <Hamburger />} */}
          </Toolbar>
        ) : (
          <Hamburger />
        )}
        {/* </ElevationScroll> */}
      </AppBar>
      {/* </HideOnScroll> */}
    </>
  );
}
